import store from '../configureStore';
import { apiPost } from './apiUtil';

const encodeList = (emailList: string | string[]) =>
  encodeURIComponent(Array.isArray(emailList) ? emailList.join(',') : emailList);

export const sendEmails = (emailList: string | string[], senderName: string, link: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiPost(`/email/send?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body: `to=${encodeList(emailList)}&name=${encodeURIComponent(senderName)}&link=${encodeURIComponent(link)}`,
  });
};

export const sendEmailsWithMessage = (emailList: string | string[], senderName: string, link: string, message: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiPost(`/email/send?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body: `to=${encodeList(emailList)}&name=${encodeURIComponent(senderName)}&link=${encodeURIComponent(link)}&message=${encodeURIComponent(message)}`,
  });
};

/**
 * The email API answers HTTP 200 with "ERROR: …" when it refuses to send.
 * Returns a message for the user, or null when the email went out.
 */
export function emailSendError(res: unknown): string | null {
  const text = (res as { response?: unknown } | undefined)?.response;
  if (typeof text !== 'string' || !text.startsWith('ERROR')) return null;
  // The email is still sent as plain text when the HTML template is missing
  if (text.includes('could not load template')) return null;
  if (text.includes('invalid email format')) return 'One of the email addresses isn’t valid.';
  if (text.includes('too many recipients')) return 'Too many recipients. Send to 50 people or fewer at a time.';
  if (text.includes('recipient missing')) return 'Add at least one email address.';
  if (text.includes('invalid link')) return 'This share link is no longer valid. Close the dialog and share the files again.';
  if (text.includes('name and/or link missing')) return 'Add your first and last name in Account settings, then try again.';
  if (text.includes('not allowed')) return 'You can’t send email from this workspace.';
  return 'Could not send email.';
}
